import { handleError } from "../utils/handleError";

function generateCurl(url, options = {}) {
  try {
    let curlCommand = `curl '${url}'`;

    // Method
    if (options.method) {
      curlCommand += ` -X ${options.method}`;
    }

    // Headers
    if (options.headers) {
      Object.entries(options.headers).forEach(([key, value]) => {
        curlCommand += ` -H '${key}: ${value}'`;
      });
    }

    // Body
    if (options.body) {
      // Assuming the body is a stringifiable object or already a string.
      // For more complex scenarios, additional handling might be required.
      let bodyData = options.body;
      // Attempt to handle JSON body by stringifying if it appears to be an object
      if (typeof bodyData === "object") {
        try {
          bodyData = JSON.stringify(bodyData);
          // Add a Content-Type header if not already present
          if (!options.headers || !options.headers["Content-Type"]) {
            curlCommand += " -H 'Content-Type: application/json'";
          }
        } catch (error) {
          console.warn("Could not stringify body:", error);
        }
      }
      curlCommand += ` --data '${bodyData}'`;
    }

    return curlCommand;
  } catch (error) {
    handleError({
      error,
      location: "L0096226 generateCurl function",
    });
    return null;
  }
}

export default generateCurl;
